<div class="modal-header">
  <h4 class="modal-title">Съобщения</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" #messagesContainer nzForceRepaint>
  <p class="mb-2"><strong class="text-muted">Артикул: </strong>{{ adTitle }}</p>
  <p class="mb-2"><strong class="text-muted">Крайна цена: </strong>{{ adPrice.toFixed(2) }} лв.</p>
  <p>
    <strong class="text-muted">
      {{ dealParticipantType === DealParticipantType.Buyer ? 'Продавач: ' : 'Купувач: ' }}
    </strong>
    {{ interlocutorUsername }}
  </p>
  <hr>
  @if (loadingData) {
    <div>
      <div class="text-center">
        <h3>
          <i class="text-muted fa-solid fa-spinner fa-spin"></i>
        </h3>
        <h5 class="text-muted">Зареждане...</h5>
      </div>
    </div>
  } @else {
    @if (messages.length === 0) {
      <h5 class="my-4 text-muted text-center">Няма изпратени съобщения</h5>
    } @else {
      <ul class="list-unstyled">
        @for (message of messages; track message.conversationMessageId) {
          <li class="row" [class.justify-content-end]="message.isUserSender">
            <div class="col-10 mb-3" [class.text-end]="message.isUserSender">
              <span class="p-2 d-inline-block border rounded-4"
                    [style.white-space]="'pre-line'"
                    [ngClass]="{
                      'bg-primary-subtle border-primary-subtle': message.isUserSender,
                      'bg-secondary-subtle border-secondary-subtle': !message.isUserSender}">
                {{ message.content }}
              </span>
              <div class="mt-1 text-muted small">
                {{ message.dateTime | date: 'dd.MM.yyyy г. HH:mm ч.' }}
                @if (message.isUserSender && message.isRead) {
                  <span ngbTooltip="Прочетено">
                    <i class="text-success fa-solid fa-check"></i>
                  </span>
                }
              </div>
            </div>
          </li>
        }
      </ul>
    }
  }
</div>
<div class="modal-footer d-block">
  <div class="mb-3 form-floating">
    <textarea
      autofocus
      rows="6"
      class="form-control"
      placeholder="Съобщение"
      style="height: 100px"
      (keydown.enter)="onSubmit()"
      [(ngModel)]="messageContent"
      id="floatingTextarea"></textarea>
    <label for="floatingTextarea">Съобщение...</label>
  </div>
  <div class="text-end">
    <button
      type="button"
      class="me-2 btn btn-outline-secondary"
      (click)="closeModal()">
      <span>Затвори</span>
    </button>
    <button
      type="button"
      [disabled]="loadingData || loadingSubmit || !messageContent"
      class="btn btn-nz-primary"
      (click)="onSubmit()">
      @if (loadingSubmit) {
        <span class="me-2 spinner-border spinner-border-sm"></span>
      }
      <span>Изпрати</span>
    </button>
  </div>
</div>
